export default {
  USER_LOGIN_WITH_GOOGLE: 'USER_LOGIN_WITH_GOOGLE',
  USER_UPDATE_PROFILE: 'USER_UPDATE_PROFILE',
  USER_LOGOUT: 'USER_LOGOUT',
};
